module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-1-4c69a8826433a7c7c79757b1ed3dcf08.jpg";